<template>
  <div>
    <vs-popup :title="$t('UploadAttachments')" :active.sync="showModal">
      <div class="pb-10 flex flex-col gap-6" v-if="show">
        <div class="flex justify-center w-full">
          <div>
            <vue-upload-multiple-image
              @upload-success="uploadSuccess"
              @before-remove="resetForm"
              :data-images="uploadedImages"
              :maxImage="1"
              :multiple="false"
              :dragText="$t('DragAndDrop')"
              :browseText="$t('UploadFile')"
              :showEdit="false"
              :showDelete="true"
              :showPrimary="false"
            ></vue-upload-multiple-image>
          </div>
        </div>
        <div class="w-full flex justify-end">
          <vs-button
            :disabled="!payload.imageUri"
            @click.prevent="uploadImage"
            >{{ $t("Upload") }}</vs-button
          >
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<style lang="scss"></style>

<script>
import { mapActions } from "vuex";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import vSelect from "@/components/CustomVSelect.vue";

export default {
  props: {
    show: { default: false },
    attachmentTypes: { rquired: true },
    contentItemId: { required: true },
  },
  data() {
    return {
      uploadedImages: [],
      uploaderKey: 1,
      AttachmentType: null,
      payload: {},
      showError: false,
    };
  },
  computed: {
    showModal: {
      get: function () {

        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      postImage: "pettyCash/postAttachment",
    }),
    resetForm() {
      this.payload = {};
      this.uploadedImages = [];
      this.uploaderKey++;
    },
    uploadImage() {
      this.postImage(this.payload).then((response) => {
        if (response) {
          this.$emit("success");
          this.$emit("close");
          this.$swal({
            position: "center-center",
            type: "success",
            text: "فایل با موفقیت آپلود شد",
            showConfirmButton: false,
            timer: 2000,
          });
          this.AttachmentType = null;
          this.payload = {};
          this.showError = false;
        }
      });
    },
    uploadSuccess(formData, index, fileList) {
      this.payload = {
        expenseId: Number(this.$route.params.id),
        imageUri: fileList[index].path,
      };
    },
  },
  watch: {
    show() {
      this.$validator.reset();
    },
  },
  components: {
    "v-select": vSelect,
    VueUploadMultipleImage,
  },
};
</script>
